// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"style_tableContainer__8yGT5","sectionHeader":"style_sectionHeader__2oXv-"};